module.exports = __webpack_public_path__ + "static/insight-69f8b60d8d96cd0775c2a19e135acc45.png";